import cn from 'clsx';
import { forwardRef, HTMLAttributes, memo, useContext } from 'react';

import GuideContext from '../context';

import s from './GuideButton.module.scss';

type Props = HTMLAttributes<HTMLDivElement>;

const GuideButtonArea = forwardRef<HTMLDivElement, Props>(({ children, className, ...props }, ref) => {
  const { isCard } = useContext(GuideContext);

  return (
    <div className={cn(s['button-area'], isCard && s['button-area__isCard'], className)} {...props}>
      {children}
    </div>
  );
});

const MemoGuideButtonArea = memo(GuideButtonArea);
export default MemoGuideButtonArea;
